import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ContactPrivateRoute = ({ children }) => {
  const { user, loadingUser } = useAuth();
  const location = useLocation();

  if (loadingUser) {
    return <div className="contact-portal-loading">Cargando...</div>;
  }

  if (!user || !user.is_contact_portal) {
    return (
      <Navigate
        to="/contactos/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
};

export default ContactPrivateRoute;
